import $ from 'jquery';

window.copyLink = function(el) {
    var input = $(el).parents('.uk-modal-body').find('input')[0];
    input.select();
    document.execCommand("copy");
}

$('.js-wow-view-more-period-item-open').click(function () {
    const scope = $(this).parents('table');
    $('.js-wow-view-more-period-item-item', scope).removeClass('uk-hidden').addClass('wow-attr-visible');
    $(this).addClass('uk-hidden');
    $('.js-wow-view-more-period-item-close', scope).removeClass('uk-hidden');
});
$('.js-wow-view-more-period-item-close').click(function () {
    const scope = $(this).parents('table');
    $('.js-wow-view-more-period-item-item', scope).addClass('uk-hidden').removeClass('wow-attr-visible');
    $(this).addClass('uk-hidden');
    $('.js-wow-view-more-period-item-open', scope).removeClass('uk-hidden');
    $('.js-wow-view-more-period-item-subitem[aria-hidden="false"]', scope).each(function () {
        $(this).prev().find('[aria-hidden="false"]')[0].click();
    });
});

document.addEventListener('tx.search.updated', function () {
    $('.js-wow-view-more-period-item-open').click(function () {
        const scope = $(this).parents('table');
        $('.js-wow-view-more-period-item-item', scope).removeClass('uk-hidden').addClass('wow-attr-visible');
        $(this).addClass('uk-hidden');
        $('.js-wow-view-more-period-item-close', scope).removeClass('uk-hidden');
    });
    $('.js-wow-view-more-period-item-close').click(function () {
        const scope = $(this).parents('table');
        $('.js-wow-view-more-period-item-item', scope).addClass('uk-hidden').removeClass('wow-attr-visible');
        $(this).addClass('uk-hidden');
        $('.js-wow-view-more-period-item-open', scope).removeClass('uk-hidden');
        $('.js-wow-view-more-period-item-subitem[aria-hidden="false"]', scope).each(function () {
            $(this).prev().find('[aria-hidden="false"]')[0].click();
        });
    });
    $('img[js-lazyload]').lazy({
        onError: function (el) {
            $(el).attr('src', $(el).data('default'));
        }
    });
});